import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { onCall: { type: Boolean, default: false } }
  static targets = ['weekRows', 'weeks', 'navLinksContainer']

  onCallClick(event) {
    this.onCallValue = event.target.checked
  }

  onCallValueChanged() {
    const onCallShifts = this.weeksTarget.querySelectorAll(".calendar-shift:not([data-shift-oncall = 'true'])")

    onCallShifts.forEach((shift) => {
      if(this.onCallValue) {
        shift.classList.add('d-none')
      } else {
        shift.classList.remove('d-none')
      }
    })

    const navLinks = this.navLinksContainerTarget.querySelectorAll('a.nav-link')

    navLinks.forEach((link) => {
      if(link.href) {
        let url = new URL(link.href)
        url.searchParams.set('oncall', this.onCallValue)
        link.href = url.toString()
      }
    })
  }
}
